import { Center, Group, Table } from "@mantine/core";

import { IconReceipt } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import { EMPTY_MESSAGE, PRACTICE_LEDGER_COLUMN_SPAN } from "./constants/practice-ledger";

interface LedgerEmptyStateProps {
  message?: string;
}

export default function LedgerEmptyState({ message = EMPTY_MESSAGE }: LedgerEmptyStateProps) {
  return (
    <Table.Tr>
      <Table.Td colSpan={PRACTICE_LEDGER_COLUMN_SPAN}>
        <Center py="xs" w="100%" bg="gray.1" style={{ borderRadius: "var(--mantine-radius-sm)" }}>
          <Group gap="xs" align="center" justify="center">
            <IconReceipt size={18} color="var(--mantine-color-gray-6)" />
            <TextWrapper c="gray.7" data-testid="practice-ledger-table-empty">
              {message}
            </TextWrapper>
          </Group>
        </Center>
      </Table.Td>
    </Table.Tr>
  );
}
